import type { ActivatedResource, AmActivatedResource } from '@/features/activation/types/activatedResource'
import type { MarketProgramType } from '@/types/marketProgramType'

export interface MagActivation {
  id?: number
  serviceId?: number
  startedAt?: string
  endedAt?: string
  mostExtremeFrequency?: number
  serviceActivationTargetBasisPoint?: number
  serviceActivationTarget?: number
  actualServiceActivationBasisPoint?: number
  actualServiceActivation?: number
  activatableCapacity?: number
  limitValue?: number
  actualValue?: number
}

export enum ActivationType {
  ACTIVATION = 'ACTIVATION',
  DISTURBANCE = 'DISTURBANCE',
  PREQUALIFICATION = 'PREQUALIFICATION',
  UNKNOWN = 'UNKNOWN',
}

export interface AmActivation {
  id?: string
  startedAt?: string
  endedAt?: string
  marketProgram?: string
  activatedResources?: AmActivatedResource[]
  type?: ActivationType
}

export interface Activation {
  id?: number | string
  startedAt?: string
  endedAt?: string
  marketProgram?: MarketProgramType
  activatedResources?: ActivatedResource[]
  type?: ActivationType
}
